module.exports = __webpack_public_path__ + "media/images/recruitment/landing/mv_bg-f8db60cbbe252faf9000639df39fbfe0.jpg";